import axios from "axios";
import { Config } from "../../../core/config/config";


const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/identity/auth`;

export const authService = {
    signIn: async function (username: string, password: string) {

        const body = {
            username,
            password
        };

        return axios.post(`${GATEWAY_URL}/login`, body)
            .then((response) => {
                const auth = response.data.data;
                return auth;
            });
    },
    refreshToken: async function (params: any) {

        return axios.post(`${GATEWAY_URL}/refresh-token`, params,
            {
                validateStatus: null
            }).then((response) => {
                if (response.status === 200) {
                    const auth = response.data.data;
                    return auth;
                } else {
                    return undefined;
                }
            })

    },

    changePassword: function (email: string, recoveryCode?: string) {
        try {
            // Send request
            console.log(email, recoveryCode);

            return {
                isOk: true
            };
        } catch {
            return {
                isOk: false,
                message: "Failed to change password"
            };
        }
    },
    resetPassword: function (email: string) {
        try {
            // Send request
            console.log(email);

            return {
                isOk: true
            };
        } catch {
            return {
                isOk: false,
                message: "Failed to reset password"
            };
        }
    },
    oAuthLogout: async function (id_token: any) {
        const body = { id_token };
        return axios.post(`${GATEWAY_URL}/logout`, body).then((response) => {
            return response.data;
        });
    },
    checkOtp: async function (hash: string, otpCode: string) {

        const body = {
            hash,
            otpCode
        };

        return axios.post(`${GATEWAY_URL}/check-otp`, body)
            .then((response) => {
                const auth = response.data.data;
                return auth;
            });
    },

    reSendOtp: async function (hash: string) {

        const body = {
            hash,
        };

        return axios.post(`${GATEWAY_URL}/resend-otp`, body)
            .then((response) => {
                const auth = response.data;
                return auth;
            }).catch((r) => {
                const data = r.response.data;
                return data;
            })

    },
}

export default authService